import { render, staticRenderFns } from "./ClockView.vue?vue&type=template&id=3e45403f&scoped=true&"
import script from "./ClockView.vue?vue&type=script&lang=js&"
export * from "./ClockView.vue?vue&type=script&lang=js&"
import style0 from "./ClockView.vue?vue&type=style&index=0&id=3e45403f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e45403f",
  null
  
)

export default component.exports